import { css } from 'styled-components';

export default css`
  table {
    margin-bottom: 0;
  }
`;
